/* 🤖 this file was generated by script */
export const wsolidiconMessageCheckCircle = {
  name: 'message_check_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.5 2a9.5 9.5 0 0 0-8.9 12.88l.01.02-.13.27-1.66 3.05-.28.56c-.07.17-.2.49-.13.86.07.43.32.82.7 1.05.32.2.65.2.84.2q.3-.01.62-.05l5.16-.53.16-.02h.01l.19.08q1.6.62 3.41.63a9.5 9.5 0 1 0 0-19m4.2 7.7a1 1 0 0 0-1.4-1.4l-3.8 3.79-1.3-1.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0z" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
